import Reveal from "./Reveal";
import { MISSION_TEXT, VISION_TEXT } from "../../data/pwt";

export default function MissionVision() {
  return (
    <section
      id="mission"
      data-testid="mission-section"
      className="relative py-24 md:py-36 bg-[#E9EFEA]"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <Reveal>
          <span className="overline">03 — Mission &amp; Vision</span>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20">
          <Reveal>
            <div className="overline text-[#1A402B]">Our Mission</div>
            <p
              data-testid="mission-text"
              className="mt-6 font-serif text-3xl md:text-5xl leading-[1.1] tracking-tight text-[#0A140F]"
            >
              {MISSION_TEXT}
            </p>
          </Reveal>
          <Reveal delay={140}>
            <div className="overline text-[#1A402B]">Our Vision</div>
            <p
              data-testid="vision-text"
              className="mt-6 font-serif text-3xl md:text-5xl leading-[1.1] tracking-tight text-[#0A140F]"
            >
              {VISION_TEXT}
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
